import { render } from "./ViewsDialog.vue?vue&type=template&id=d079a25c"
import script from "./ViewsDialog.vue?vue&type=script&lang=js"
export * from "./ViewsDialog.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "d079a25c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d079a25c', script)) {
    api.reload('d079a25c', script)
  }
  
  module.hot.accept("./ViewsDialog.vue?vue&type=template&id=d079a25c", () => {
    api.rerender('d079a25c', render)
  })

}

script.__file = "src/components/ms-puns-message/ViewsDialog.vue"

export default script